module.exports = __webpack_public_path__ + "static/media/CleaningCompaniesAdmin.ae8b4cf0.PNG";